'use client'
import { setLanguages } from '@/app/globalRedux/filter/newsFilter'
import { AppDispatch, RootState } from '@/app/globalRedux/store'
import { languageTransition } from '@/app/utils/language'
import { getCountryList } from '@/services/generalDataServices'
import { useParams, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import RightAdsPanel from '../../components/AdsFructidor/RightAdsPanel/RightAdsPanel'
import CustomErrorBoundary from '../../ErrorBoundary'
import { NewsPage } from '../search/news-tab/(components)/NewsPage'
export const NewsListingpage = () => {
  const params = useParams<{ lng: string }>()
  const dispatch: AppDispatch = useDispatch()
  const searchParams = useSearchParams()

  const countryList = useSelector(
    (state: RootState) => state.constantData.countriesList
  )

  useEffect(() => {
    if (countryList?.length <= 0) {
      dispatch(getCountryList())
    }
  }, [])

  useEffect(() => {
    const queryLang = searchParams.get('newslng')
    const routeLang = params?.lng
    const selectedLang = queryLang || routeLang

    // Check for newslang filter applied if not use the lng
    const language =
      languageTransition.find(
        (e) => e.path === selectedLang || e.language === selectedLang
      )?.language ?? 'English'

    dispatch(setLanguages(language))
  }, [searchParams, params])

  return (
    <div>
      <div className="flex justify-center mt-[30px]">
        <div className="w-[1280px] flex justify-between mobile-width mobile:flex-col">
          <div className="mb-[30px]">
            <CustomErrorBoundary>
              <NewsPage />
            </CustomErrorBoundary>
          </div>
          <RightAdsPanel />
        </div>
      </div>
    </div>
  )
}

export default NewsListingpage
